import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import configureStore from './redux';
import { MemoryRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import icimsI18next from '@icimscorp/i18next';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import CircleProgress from '@material-ui/core/CircularProgress';
import CatchAllErrors from 'components/CatchAllError';
import Root from 'components/Root';
import pkg from '../package.json';
import { merge } from 'lodash';
import { lightConfig } from '@icimscorp/mui/build/theme';
import { lightThemeAcs } from '@icimscorp/mui-acs/build/acs-theme';

import config from 'config';

export const store = configureStore();
const lightTheme = createTheme(merge({}, lightConfig, lightThemeAcs));

export default function App() {
	return (
		<I18nextProvider
			i18n={icimsI18next({
				defaultLanguage: 'en-US',
				defaultNs: pkg.translations.namespaces[0],
				ns: pkg.translations.namespaces
			})}
		>
			<ThemeProvider theme={lightTheme}>
				<React.Suspense fallback={<CircleProgress />}>
					<ReduxProvider store={store}>
						<MemoryRouter basename={config.basename}>
							<CatchAllErrors>
								<Root />
							</CatchAllErrors>
						</MemoryRouter>
					</ReduxProvider>
				</React.Suspense>
			</ThemeProvider>
		</I18nextProvider>
	);
}
